import Api from "./Api";
import Api_2 from "./Api_extra";
import { createQueryString } from "./ApiHelper";

export default {
  GetHardwareName(payload) {
    return Api().post("/api/pos/gethardwarename", payload);
  },
  updateSeatStatus(payload) {
    return Api().put("/update-seat-status", payload);
  },
  getOrgDetails() {
    return Api().get("/api/pos/getOrgDetails");
  },
  getCashInput() {
    return Api().get(`/api/pos/cashinput`);
  },
  getCashDenominations() {
    return Api().get(`/api/pos/cashdenominations`);
  },
  onCloseShift(payload) {
    return Api().post(`/api/pos/shift_close`, payload);
  },
  getMovieDetails(payload) {
    return Api().post("/api/pos/getMovieDetails", payload);
  },
  getOccupancyStatus(payload) {
    return Api().post("/api/pos/getOccupancyStatus", payload);
  },
  getActiveScreens() {
    return Api().get("/api/pos/getActiveScreens");
  },
  UpdateCashCardAmount(payload) {
    return Api().put("/api/pos/updatecashcardamount", payload);
  },
  //This route using also for makeARefund in exhibitor
  getRefundReason(payload) {
    return Api().post("/api/pos/refund", payload);
  },
  //This route using also for makeARefund in exhibitor
  updateRefundStatus(payload) {
    return Api().put("/api/cinema/admin/generate-bo-fnb-refund", payload);
  },
  PaymentGatewayRefundApi(payload) {
    console.log(payload);
    if (payload.pm_payment_mode == "Amazon PayFort")
      return Api().post("/api/cinema/pay-ford/refund-api", payload);
    else if (payload.pm_payment_mode == "Master/Visa")
      return Api().post("/api/cinema/master-card/refund-api", payload);
    else if (payload.pm_payment_mode == "Al Rajhi Bank")
      return Api().post("/api/cinema/alrajhi/refund-api", payload);
    else if (payload.pm_payment_mode == "Secure Acceptance Checkout")
      return Api().post("/api/cinema/secure-acceptance/refund-api", payload);
    else if (payload.pm_payment_mode == "CC AVENUE")
      return Api().post("/api/cinema/cc-avenue/refund-api", payload);
    else if (payload.pm_payment_mode == "TAP Pay")
      return Api().post("/api/cinema/tap-pay/refund-api", payload);
    else if (payload.pm_payment_mode == "Bank Muscat")
      return Api().post("/api/cinema/bank-muscat/refund-api", payload);
    else if (payload.pm_payment_mode == "MASTER CARD ASF")
      return Api().post("/api/cinema/master-card-asf/refund-api", payload);
    else if (payload.pm_payment_mode == "MASTER CARD SC")
      return Api().post("/api/cinema/master-card-sc/refund-api", payload);
    else if (payload.pm_payment_mode == "BENEFIT CARD")
      return Api().post("/api/cinema/benefit-card/refund-api", payload);
    else if (payload.pm_payment_mode == "Khalti E-Payment")
      return Api().post("/api/cinema/khalti/refund-api", payload);
    else if (payload.pm_payment_mode == "Mid Trans")
      return Api().post("/api/admin/midtrans-refund", payload);
    else if (payload.pm_payment_mode == "Dibsy")
      return Api().post("/api/dibsy/dibsy-refund", payload);
    else return Promise.reject(new Error("Invalid payment mode"));
  },
  PaymentGatewayVoidApi(payload) {
    if (payload.pm_payment_mode == "Secure Acceptance Checkout")
      return Api().post("/api/cinema/secure-acceptance/void-api", payload);
    else return Promise.reject(new Error("Invalid payment mode"));
  },
  AlrajhiInquiryPayment(payload) {
    return Api().post("/api/cinema/alrajhi/inquiry-payment", payload);
  },
  SecureAcceptanceInquiryPayment(payload) {
    return Api().post("/api/cinema/secure-acceptance/inquiry-payment", payload);
  },
  CCAvenueInquiryPayment(payload) {
    return Api().post("/api/cinema/cc-avenue/inquiry-payment", payload);
  },
  TapPayInquiryPayment(payload) {
    return Api().post("/api/cinema/tap-pay/inquiry-payment", payload);
  },
  updateRefunds(payload) {
    //For Show Transactions
    return Api().put("/api/pos/refundstatus", payload);
  },
  updateFloatAmountRecord(payload) {
    return Api().put("/api/pos/cashinput", payload);
  },
  getAllShows(payload) {
    return Api().post("/api/pos/getAllShows", payload);
  },
  getSeatLayout(payload) {
    // return Api().post('/getSeatLayout', payload)
    // getYKSeatLayout
    return Api().post("/getYKSeatLayout", payload);
  },
  GetCustomerLoyaltyPointsBYID(payload) {
    return Api().get(
      `/api/pos/customerloyaltypoints/${payload.clp_id}?limit=${payload.limit}&currentPage=${payload.currentPage}`
    );
  },
  getSeatType(payload) {
    return Api().get(
      `/api/admin/tablelist/screen_seat_type?sst_is_active=Y&screen_id=${payload.screen_id}`
    );
  },
  getCustomersList(payload) {
    return Api().get(`/api/admin/tablelist/customers?cust_is_active=Y`);
  },
  getAllDates() {
    return Api().get("/api/pos/getAllDates");
  },
  getMovieLanguages() {
    return Api().get("/api/pos/getMovieLanguages");
  },
  getMovieGenre() {
    return Api().get("/api/pos/getMovieGenres");
  },
  getMovieFormats() {
    return Api().get("/api/pos/getMovieFormats");
  },
  AddCashCard(payload) {
    return Api().post("/api/pos/cashcard", payload);
  },
  reserveSeat(payload) {
    return Api().post("/reserveSeat", payload);
  },
  show_bookings(payload) {
    return Api().post("/api/pos/show_bookings", payload);
  },
  show_seat_bookings(payload) {
    return Api().post("/api/pos/show_seat_bookings", payload);
  },
  updateBookingStatus(payload) {
    return Api().post("/api/pos/updateBookingStatus", payload);
  },
  getBookingDetails(payload) {
    return Api().post("/api/pos/getBookingDetails", payload);
  },
  pickupTicket(payload) {
    return Api().post("/api/pos/pickup-ticket", payload);
  },
  GetReservationDetails(payload) {
    return Api().post("/api/pos/reservation-details", payload);
  },
  getAdditionalCharges(payload) {
    return Api().post("/api/pos/get-additional-charges", payload);
  },

  //Not using anywhere
  NewAdditionalCharges(payload) {
    return Api().post("/new-additional-charges", payload);
  },

  // POS
  PosBoxOfficeTransactions(payload) {
    return Api().post(`/pos/admin/transactions`, payload);
  },

  // New Booking APIs
  PosGetSeatLayout(payload) {
    return Api().post("/api/pos/v1.1/getSeatLayout", payload);
  },
  PosReserveSeat(payload) {
    return Api().post("/api/pos/v1.1/reserveSeats", payload);
  },
  releaseSeatIndividually(payload) {
    return Api().post("/api/pos/v1.1/releaseSeatIndividually", payload);
  },
  PosReleaseSeats(payload) {
    return Api().post("/api/pos/v1.1/releaseSeats", payload);
  },
  PosReleaseRealtimeSeats(payload) {
    return Api().post("/api/pos/v1.1/releaseRealtimeBookedSeats", payload);
  },
  PosBookSeats(payload) {
    return Api().post("/api/pos/v1.1/bookSeats", payload);
  },
  VerifyCardNumber(payload) {
    return Api().post("/api/pos/v1.1/verifycard", payload);
  },
  PosBookingDetails(payload) {
    return Api().post("/api/pos/v1.1/getBookingDetails", payload);
  },
  PosBookingDetailsEmpire(payload) {
    return Api().post("/api/pos/v1.1/getBookingDetailsEmpire", payload);
  },

  updateCustomerData(payload) {
    return Api().post("/api/pos/update-customer-data", payload);
  },
  UpdateCustomerBookingDetails(payload) {
    return Api().post("/api/pos/update-customer-booking-details", payload);
  },

  InsertCustomerBookingDetails(payload) {
    return Api().post("/api/pos/insertCustomerDetails", payload);
  },
  InsertOnlyCustomerDetails(payload) {
    return Api().post("/api/pos/insertOnlyCustomerDetails", payload);
  },
  SendSMS(payload) {
    return Api().post("/api/pos/sendSMS", payload);
  },
  SendEmail(payload) {
    return Api().post("api/pos/sendEmail", payload);
  },
  // /api/pos/get-fnb-pricing
  GetFnbItemPricing(payload) {
    return Api().post("/api/pos/get-fnb-pricing", payload);
  },
  /**
   * POS BOOKING
   */
  OnStartPosUserShiftLog(payload) {
    return Api().post("/api/pos/pos-user-shift-log", payload);
  },
  // OnGetPosUserShiftLog(payload) {
  // },
  OnClosePosUserShiftLog(payload) {
    return Api().put("/api/pos/pos-user-shift-close", payload);
  },
  OnQuitPosUserShift(payload) {
    return Api().put("/api/pos/pos-user-shift-quit", payload);
  },
  // GetPosUsersShiftDetails() {
  //     return Api().get('/get-user-shift-close-logs');
  // }

  /**
   * POS BOOKING END
   */
  shiftChecker() {
    return Api().get("/api/pos/getshiftChecker");
  },

  GetTicketEjs(sb_id, cinema_id, isReprint = false) {
    return Api_2().get(
      `/api/pos/generate-ticket/${sb_id}/${cinema_id}?isReprint=${isReprint}`
    );
  },
  GetWOWTicketEjs(
    sb_id,
    cinema_id,
    OrderCode,
    isReprint = false,
    isRefund = false
  ) {
    return Api_2().get(
      `/api/pos/boplusfnb-ticket/${sb_id}/${cinema_id}/${OrderCode}/${isRefund}?isReprint=${isReprint}`
    );
  },
  getQfxEntrancePass(payload) {
    let qs = "";
    if (payload.t_id) {
      qs = `?t_id=${payload.t_id}`;
    }
    return Api().get(`/api/pos/generate-entrance-ticket/${payload.sb_id}${qs}`);
  },

  GetRefundTicketEjs(sb_id, cinema_id, isReprint = false, isRefund = true) {
    return Api_2().get(
      `/api/pos/generate-refund-ticket/${sb_id}/${cinema_id}?isReprint=${isReprint}`
    );
  },

  GetAddonTicketEjs(payload) {
    let {
      addOns,
      bookingDetails,
      isReprint = false,
      isRefund = false,
    } = payload;
    return Api().get(
      `/api/pos/generate-addon-ticket?isReprint=${isReprint}&addOns=${addOns}&bookingDetails=${bookingDetails}&isRefund=${isRefund}`
    );
  },

  //new empire ticket
  GetEmpireTicketEjs(t_id, cinema_id, isReprint = false) {
    return Api().get(
      `/api/pos/generate-empire-ticket/${t_id}/${cinema_id}?isReprint=${isReprint}`
    );
  },

  GetTicketSecurityEjs(
    sb_id,
    cinema_id,
    isReprint = false,
    addOnsArr = [],
    isRefund = false
  ) {
    return Api().get(
      `/api/pos/generate-security-ticket/${sb_id}/${cinema_id}?isReprint=${isReprint}&addOnData=${addOnsArr}&isRefund=${isRefund}`
    );
  },
  GetBoxOffice_FnbTicketEjs(
    sb_id,
    ft_id = 0,
    cinema_id,
    flag,
    isReprint = false,
    isRefund = false
  ) {
    console.log("1", ft_id);
    let ftId = ft_id ? ft_id : 0;
    return Api().get(
      `/api/pos/generate-receipt/${sb_id}/${ftId}/${cinema_id}?flag=${flag}&isReprint=${isReprint}&isRefund=${isRefund}`
    );
  },
  GetReceiptEjs(sb_id, ft_id = 0, cinema_id, flag) {
    console.log("2", ft_id);
    let ftId = ft_id ? ft_id : 0;
    return Api().get(
      `/api/pos/generate-receipt/${sb_id}/${ftId}/${cinema_id}?flag=${flag}`
    );
  },
  //get Cash Cards
  GetCashCards(payload) {
    return Api().get(`/api/pos/getcashcards/${payload.customer_id}`);
  },
  GetCashCardLogs(payload) {
    const { cash_card_id } = payload;
    const query = createQueryString(payload);
    return Api().get(`/api/pos/getcashcardlogs/${cash_card_id}/${query}`);
  },
  CheckBalance(cash_card_id) {
    return Api().get(`/api/pos/checkcashcardbalance/${cash_card_id}`);
  },
  ValidateBalance(payload) {
    return Api().post(`/api/pos/checkusedcashcardbalance`, payload);
  },
  //get valid payment modes
  GetValidPaymentModes(payload) {
    return Api().get(`/api/pos/getvalidpaymentmodes/${payload}`);
  },
  ValidatePoints(payload) {
    return Api().post("/api/pos/validate_points", payload);
  },
  //Shifted from userservice
  CheckCinemaManagerLogin(payload) {
    return Api().post("/api/pos/checkCinemaManagerLogin", payload);
  },
  //Shifted from userservice
  CheckCinemaManagerAuth(payload) {
    return Api().post("/api/pos/checkCinemaManagerAuth", payload);
  },
  //Shifted from scheduleService
  getReservesSeatLayout(payload) {
    return Api().post("/api/pos/getSeatLayout", payload);
  },
  //GetMenus
  GetPosFooterMenus() {
    return Api().get("/api/pos/posfootermenus");
  },
  ConvertCurrency(payload) {
    return Api().post("/api/admin/convert-currency", payload);
  },
  GetFnbOrderDetails(payload) {
    return Api().get(`/pos/admin/checkRefund/${payload.order_code}`);
  },
  fnbRefund(payload) {
    // return Api().post(`/pos/admin/fnbRefund`, payload);
    return Api().post(`/api/cinema/generate-only-fnb-refund`, payload);
  },
  getPosUserCollection(payload) {
    const query = createQueryString(payload);
    return Api().get(`/api/pos/getUserCollection/${payload.user_id}${query}`);
  },
  getShiftCloseInvoiceSummary(payload) {
    const query = createQueryString(payload);
    return Api().get(
      `api/pos/shiftCloseInvoiceSummary/${payload.user_id}${query}`
    );
  },
  getPosUserTransactions(payload) {
    const query = createQueryString(payload);
    return Api().post(
      `/api/pos/getUserTransaction/${payload.user_id}`,
      payload
    );
  },
  insertCustomerBooking(payload) {
    return Api().post(`/api/pos/updateCustomerBooking`, payload);
  },
  AddComment(payload) {
    return Api().post(`/api/pos/updateTransactionComment`, payload);
  },
  GetCashCardList(payload) {
    let query = createQueryString(payload);
    return Api().get(`/api/pos/getcashcardlist/${query}`);
  },
  TopUpCashCard(payload) {
    return Api().post(`/api/pos/credit-cash-card`, payload);
  },
  getCashCardReceipt(payload) {
    return Api().get(
      `/api/pos//cash_card_receipt/${payload.cash_card_id}/${payload.cash_card_log_id}?isReprint=${payload.isReprint}`
    );
  },
  getRateCardAddonsByReservation(payload) {
    return Api().get(
      `/api/admin/get-rate-card-addons-by-id?reservation_id=${payload.reservation_id}`
    );
  },
  GetPosLocationsUsers(payload) {
    return Api().get(`/api/pos/getUserOtherLocations/${payload.user_id}`);
  },
  changeLoggedUserCinema(payload) {
    return Api().post(`/api/pos/changePosUserCinema`, payload);
  },
  getTLLOgs(payload) {
    return Api().get(`/api/admin/v2/tl-logs/${payload.usl_id}`);
  },
  ValidateEWalletCustomer(payload) {
    return Api().post(`/api/e_wallet/send_otp`, payload);
  },
  VerifyEWalletCustomerByOtp(payload) {
    return Api().post(`/api/e_wallet/verify_otp/balance`, payload);
  },
  getWalletBalance(payload) {
    return Api().post(`/api/e_wallet/getbalance`, payload);
  },
  TopUpWallet(payload) {
    return Api().post(`/api/e_wallet/recharge`, payload);
  },
  getWalletHistoryLogs(payload) {
    return Api().post(`/api/e_wallet/eWallet_logs`, payload);
  },
  CHECK_LIMIT_REPRINT(payload) {
    let qs = ``;
    if (payload.onlyCheck) {
      qs = `?onlyCheck=${payload.onlyCheck}`;
    }
    return Api().get(`/api/pos/checkReprintExist/${payload.sb_id}${qs}`);
  },
  CHECK_LIMIT_REPRINT_FNB(payload) {
    let ftId =
      payload.hasOwnProperty("ft_id") && payload["ft_id"]
        ? payload.ft_id
        : null;

    let extraQuery = ``;
    if (ftId) {
      extraQuery = `?ft_id=${ftId}`;
    }
    return Api().get(
      `/api/pos/checkReprintExistFnb/${payload.orderCode}${extraQuery}`
    );
  },
};



// WEBPACK FOOTER //
// ./src/services/PosService.js